/**
 * @module "model/rule.model"
 * @description The Rule Model contains a list of conditions that need to be met for
 * an action (default is displayed) to be executed. TemplateObjectModels will use
 * these rules, for example, to determine whether or not to display a templateObject
 * for progressive disclosure. See another example of a different type rule below:
 *
 *  @example
 *  {
 *      name: 'required_rule',
 *      action: 'validate',
 *      conditions: [{
 *          operation: 'filled'
 *      }],
 *      hidden: true
 *  }
 */

define('formkit/model/rule.model',['require','exports','module','./base.model','./condition.model','uuid'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel      = require('./base.model'),
      ConditionModel = require('./condition.model'),
      UUID           = require('uuid');

  /**
   * @class Rule
   * @augments BaseModel
   * @see {@link model/base.model.js}
   * @see {@link model/condition.model.js}
   * @property {Object} childModels - an object containing condition childModels
   */
  var Rule = BaseModel.extend({
    /**
     * @method defaults
     *
     * @returns {Object}  an object with an id, name, action, and conditions.
     */

    defaults: function() {
      return {
        id: UUID.generate(),
        name: '',
        /**
         * @todo change this (action default) to empty string and properly handle action in the future
         */
        action: 'displayed',
        conditions: [],
      };
    },

    childModels: {
      conditions: ConditionModel,
    },
  });

  module.exports = Rule;
});

